import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative my-8 w-full gap-x-8 rounded-4 border border-dashed border-black-300 bg-black-50 px-8 py-8 text-center text-14 text-black-900"
}
const _hoisted_2 = { class: "pr-16 leading-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return ($props.cartHasItems)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          ($props.isCustomDiscountApplicable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString($props.customDiscount.applied_discount_text), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString($props.formattedDiscountRemainingAmountText), 1)
              ], 64))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "absolute right-4 top-4 tablet:right-8 tablet:top-8",
          onClick: _cache[0] || (_cache[0] = $event => ($props.setShowCustomDiscountPopup(false)))
        }, [
          _createVNode(_component_v_icon, {
            icon: "close",
            width: 9,
            height: 9,
            color: "#605F5F"
          })
        ])
      ], 512)), [
        [_vShow, $props.showCustomDiscountPopup]
      ])
    : _createCommentVNode("", true)
}